<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>全天为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name, item)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt class="dtClass" v-for="(i, n) in item.children" :key="n">
              <div @click="subClick(i)">{{ i.name }}</div>
            </dt>
          </dl>
        </li>
      </ul>
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png" />
      </div>
      <div id="changeLanguage" @click="changeLanguage()">
        <!-- <span>{{$t('header.home')}}</span> -->
        <img
          class="language"
          v-if="this.$i18n.locale === 'en'"
          src="@/assets/img/en.png"
        />
        <img class="language" v-else src="@/assets/img/zh.png" />
      </div>
    </div>

    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div style="display: flex">
        <div>
          <i
            @click="drawer = !drawer"
            class="el-icon-s-unfold"
            style="
              color: rgb(0, 137, 205) !important;
              font-size: 4rem;
              line-height: 80px;
              margin-left: 10%;
            "
          ></i>
        </div>
        <div class="header-nav-m-logo">
          <img
            class="center-block"
            src="@/assets/img/logo_black.png"
            alt="logo"
          />
        </div>
      </div>
      <!-- 导航栏 -->

      <el-drawer
        title="导航栏"
        :visible.sync="drawer"
        :direction="direction"
        :with-header="false"
        :modal="false"
      >
        <div style="background: #fff; height: 20px"></div>
        <div id="changeLanguage-m" @click="changeLanguage()">
          <!-- <span>{{$t('header.home')}}</span> -->

          <img
            class="language"
            v-if="this.$i18n.locale === 'en'"
            src="@/assets/img/en.png"
          />
          <img class="language" v-else src="@/assets/img/zh.png" />
        </div>
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="rgb(0, 137, 205)"
        >
          <el-menu-item index="1" @click="navClickM(0)">
            <span slot="title">{{ $t("header.home") }}</span>
          </el-menu-item>
          <el-submenu index="2" @click="navClickM(1)">
            <template slot="title">
              <span>{{ $t("header.product") }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                v-for="(i, index) in navList[2].children"
                :index="index + 1"
                :key="index"
                @click="subClick(i)"
                >{{ i.name }}</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="3" @click="navClickM(2)">
            <span slot="title">{{ $t("header.company") }}</span>
          </el-menu-item>
          <el-menu-item index="4" @click="navClickM(3)">
            <span slot="title">{{ $t("header.contactUs") }}</span>
          </el-menu-item>
          <el-menu-item index="5" @click="navClickM(4)">
            <span slot="title">{{ $t("header.companyDynamics") }}</span>
          </el-menu-item>
        </el-menu>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import bus from "../utils/bus";
import changeLanguage from "./changeLanguage.vue";
import { getProductCategory } from "../http/api/product.js";
export default {
  name: "Header",
  components: {
    changeLanguage
  },
  data() {
    return {
      drawer: false,
      direction: "ltr",
      flag: false,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: this.$t("header.home"),
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: this.$t("header.home"),
          path: "/",
          children: []
        },
        {
          name: this.$t("header.company"),
          path: "/companyintroduction",
          children: []
        },
        {
          name: this.$t("header.product"),
          path: "",
          children: []
        },
        {
          name: this.$t("header.companyDynamics"),
          path: "/companyDynamics",
          children: []
        },
        {
          name: this.$t("header.contactUs"),
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  mounted() {
    this.navList = [
      {
        name: this.$t("header.home"),
        path: "/",
        children: []
      },
      {
        name: this.$t("header.company"),
        path: "/companyintroduction",
        children: []
      },
      {
        name: this.$t("header.product"),
        path: "",
        children: []
      },
      {
        name: this.$t("header.companyDynamics"),
        path: "/companyDynamics",
        children: []
      },
      {
        name: this.$t("header.contactUs"),
        path: "/contactus",
        children: []
      }
    ];
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动

    getProductCategory({
      current: 1,
      size: 99
    }).then(res => {
      if (this.$i18n.locale === "zh") {
        res.content.forEach(e => {
          e.path = "/product";
        });
        this.navList[2].children = res.content;
      } else {
        res.content.forEach(e => {
          e.path = "/product";
          e.name = e.nameEn;
        });
        this.navList[2].children = res.content;
      }
    });
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.drawer = false;
      }
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    navClick(index, name, item) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      if (item.path !== "") {
        this.$router.push(item.path);
      } else {
        sessionStorage.setItem("navIndex", 2);
        this.$router.push({
          path: "./product",
          query: {
            fCategory: item.children[0]
          }
        });
      }
    },
    navClickM(index) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      if (index === 0) {
        this.$router.push("/");
      } else if (index === 1) {
        this.$router.push({
          path: "./product",
          query: {
            fCategory: this.navList[2].children[0]
          }
        });
      } else if (index === 2) {
        this.$router.push("/companyintroduction");
      } else if (index === 3) {
        this.$router.push("/contactus");
      } else if (index === 4) {
        this.$router.push("/companyDynamics");
      }
    },
    subClick(item) {
      sessionStorage.setItem("navIndex", 2);
      bus.$emit("send", item);
      this.$router.push({
        path: "./product",
        query: {
          fCategory: item
        }
      });
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    changeLanguage() {
      this.$i18n.locale == "zh"
        ? (this.$i18n.locale = "en")
        : (this.$i18n.locale = "zh"); //设置中英文模式
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置

      this.navList = [
        {
          name: this.$t("header.home"),
          path: "/",
          children: []
        },
        {
          name: this.$t("header.company"),
          path: "/companyintroduction",
          children: []
        },
        {
          name: this.$t("header.product"),
          path: "",
          children: []
        },
        {
          name: this.$t("header.companyDynamics"),
          path: "/companyDynamics",
          children: []
        },
        {
          name: this.$t("header.contactUs"),
          path: "/contactus",
          children: []
        }
      ];
      getProductCategory({
        current: 1,
        size: 99
      }).then(res => {
        if (this.$i18n.locale === "zh") {
          res.content.forEach(e => {
            e.path = "/product";
          });
          this.navList[2].children = res.content;
        } else {
          res.content.forEach(e => {
            e.path = "/product";
            e.name = e.nameEn;
          });
          this.navList[2].children = res.content;
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
/deep/ .el-drawer__open .el-drawer.ltr {
  width: 62% !important;
}
/deep/ .el-drawer__body {
  background: #545c64;
}
.language {
  width: 45px;
  height: 45px;
}
#changeLanguage {
  height: 50px;
  position: absolute;
  top: 55px;
  right: 45px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#changeLanguage > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
/* 顶部 */
#header {
  background: #ffffff;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: rgb(0, 137, 205) !important;
}
.dtClass:hover {
  background: rgb(0, 137, 205) !important;
  color: #fff;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 140px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: right;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
  background: #fff;
  border-radius: 50%;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 140px;
  float: left;
  margin: 0;
  max-width: 900px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 25px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: rgb(6, 107, 177);
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: rgb(6, 107, 177);
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: rgb(6, 107, 177);
  text-decoration: none;
  border-bottom: 2px solid rgb(6, 107, 177);
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: -30%;
  margin-left: -30%;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */
/* =================================================================================================================== */

@media screen and (max-width: 997px) {
  #header {
    height: 80px;
  }
  #header .header-nav-m {
    position: relative;
    display: flex;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: absolute;
    right: 5%;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 80px;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
  #changeLanguage-m {
    height: 60px;
    text-align: -webkit-center;
    margin-top: -1px;
    background: #fff;
    // position: absolute;
    // top: 55px;
    // right: 45px;
    // bottom: 20px;
    z-index: 99999999;
    cursor: pointer;
  }
  #changeLanguage-m > span {
    display: block;
    width: 100%;
    height: 100%;
    color: rgb(8, 162, 233);
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue